import React from 'react';

import { FaSchool, FaHospital, FaPlane, FaBuilding, FaSubway, FaTruck, FaTrain, FaLaptop } from 'react-icons/fa';
import { FaRoad } from "react-icons/fa";
import { FaCity } from "react-icons/fa";
import '../Advantage/Advantage.css';

const Advantage = () => {
  const advantages = [
    { icon: <FaRoad />, text: 'FNG Expressway', drive: '5 mins drive' },
    { icon: <FaCity />, text: 'Noida City Centre', drive: '20 mins drive' },
    { icon: <FaSchool />, text: 'International schools & universities', drive: 'within 5 mins drive' },
    { icon: <FaRoad />, text: 'Delhi–Meerut Expressway', drive: '10 mins drive' },
    { icon: <FaHospital />, text: 'Fortis Hospital', drive: '20 mins drive | Yatharth Hospital - 5 mins drive' },
    { icon: <FaPlane />, text: 'Taj Expressway', drive: '25 mins drive making it accessible to Jewar International Airport' },
    { icon: <FaBuilding />, text: 'Iris Broadway Greno West', drive: 'located at the Ek Murti roundabout on 130 mtr road' },
    { icon: <FaSubway />, text: 'The development is situated', drive: 'right opposite to NMRC–proposed Metro station' },
    { icon: <FaRoad />, text: 'Ek Murti Chowk – NH-91 connectivity', drive: 'makes the mall accessible to Ghaziabad, Meerut, Dadri, and Bulandshahr' },
    { icon: <FaTruck />, text: 'Very close to the originating point', drive: 'of Eastern and Western Peripheral Expressway/DFC' },
    { icon: <FaTrain />, text: 'Greater Noida’s 1st railway station', drive: 'is proposed near Bodaki, 35 mins drive from the project' },
    { icon: <FaLaptop />, text: 'Large IT campus like IBM, R System & DELL', drive: 'in close vicinity' },
  ];

  return (
    <section className="advantage">
      <div className="advantage-header">
        <h2>A lifestyle landmark</h2>
        <p>that enjoys huge location advantages.</p>
      </div>
      <ul className="advantage-list">
        {advantages.map((adv, index) => (
          <li key={index} className="advantage-item">
            <div className="advantage-icon">{adv.icon}</div>
            <div className="advantage-info">
              <strong>{adv.text}</strong> <span>- {adv.drive}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Advantage;
